var exports = {
  "k": "x127c5a35--ce109a--container",
};

module.exports = exports;
